// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader-textCenter-_W1PN {
  text-align: center;
}

.Loader-fullPageGifLoader-lyaQP {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
          transform: translateY(-50%);
}

.Loader-fullPageGifLoader-lyaQP img {
  width: 80px;
  height: 80px;
}

@media (max-width: 480px) {
  .Loader-fullPageGifLoader-lyaQP img {
    width: 45px;
    height: 45px;
  }
}

/* custom circle loader */

.Loader-customCircleLoad-V0rul {
  border-radius: 50%;
  border-style: solid;
  -webkit-animation:
    Loader-customCircleOne-Y5tJO 0.8s infinite linear alternate,
    Loader-customCircleTwo-ycPU8 1.6s infinite linear;
          animation:
    Loader-customCircleOne-Y5tJO 0.8s infinite linear alternate,
    Loader-customCircleTwo-ycPU8 1.6s infinite linear;
  display: inline-block;
  vertical-align: middle;
}

@-webkit-keyframes Loader-customCircleOne-Y5tJO {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
  }

  12.5% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
  }

  50% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }

  62.5% {
    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }

  75% {
    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
  }

  100% {
    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
  }
}

@keyframes Loader-customCircleOne-Y5tJO {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
  }

  12.5% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
  }

  50% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }

  62.5% {
    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }

  75% {
    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
  }

  100% {
    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
  }
}

@-webkit-keyframes Loader-customCircleTwo-ycPU8 {
  0% {
    -webkit-transform: scaleY(1) rotate(0deg);
            transform: scaleY(1) rotate(0deg)
  }

  49.99% {
    -webkit-transform: scaleY(1) rotate(135deg);
            transform: scaleY(1) rotate(135deg)
  }

  50% {
    -webkit-transform: scaleY(-1) rotate(0deg);
            transform: scaleY(-1) rotate(0deg)
  }

  100% {
    -webkit-transform: scaleY(-1) rotate(-135deg);
            transform: scaleY(-1) rotate(-135deg)
  }
}

@keyframes Loader-customCircleTwo-ycPU8 {
  0% {
    -webkit-transform: scaleY(1) rotate(0deg);
            transform: scaleY(1) rotate(0deg)
  }

  49.99% {
    -webkit-transform: scaleY(1) rotate(135deg);
            transform: scaleY(1) rotate(135deg)
  }

  50% {
    -webkit-transform: scaleY(-1) rotate(0deg);
            transform: scaleY(-1) rotate(0deg)
  }

  100% {
    -webkit-transform: scaleY(-1) rotate(-135deg);
            transform: scaleY(-1) rotate(-135deg)
  }
}

/* text loader */

.Loader-loadingTextContainer-uqYo4 p {
  margin-bottom: 0;
}

.Loader-loadingTextWrapper-smZ3y {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
}

.Loader-loadingTextWrapper-smZ3y .Loader-loadingTextSpan-XOUfv {
  -webkit-animation-name: Loader-blink-ZVBPT;
          animation-name: Loader-blink-ZVBPT;
  -webkit-animation-duration: 1.4s;
          animation-duration: 1.4s;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
  width: 8px;
  height: 8px;
  display: inline-block;
  background: var(--primary-foreground);
  border-radius: 50%;
}

.Loader-loadingTextWrapper-smZ3y .Loader-loadingTextSpan-XOUfv:nth-child(2) {
  -webkit-animation-delay: .2s;
          animation-delay: .2s;
}

.Loader-loadingTextWrapper-smZ3y .Loader-loadingTextSpan-XOUfv:nth-child(3) {
  -webkit-animation-delay: .4s;
          animation-delay: .4s;
}

@-webkit-keyframes Loader-blink-ZVBPT {
  0% {
    opacity: .2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: .2;
  }
}

@keyframes Loader-blink-ZVBPT {
  0% {
    opacity: .2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: .2;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Loader/Loader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB;;qDAEsC;UAFtC;;qDAEsC;EACtC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AA5BA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,yCAAgC;YAAhC;EACF;;EAEA;IACE,2CAAkC;YAAlC;EACF;;EAEA;IACE,0CAAiC;YAAjC;EACF;;EAEA;IACE,6CAAoC;YAApC;EACF;AACF;;AAhBA;EACE;IACE,yCAAgC;YAAhC;EACF;;EAEA;IACE,2CAAkC;YAAlC;EACF;;EAEA;IACE,0CAAiC;YAAjC;EACF;;EAEA;IACE,6CAAoC;YAApC;EACF;AACF;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0CAAqB;UAArB,kCAAqB;EACrB,gCAAwB;UAAxB,wBAAwB;EACxB,2CAAmC;UAAnC,mCAAmC;EACnC,iCAAyB;UAAzB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,4BAAoB;UAApB,oBAAoB;AACtB;;AAEA;EACE,4BAAoB;UAApB,oBAAoB;AACtB;;AAGA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAZA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".textCenter {\n  text-align: center;\n}\n\n.fullPageGifLoader {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  transform: translateY(-50%);\n}\n\n.fullPageGifLoader img {\n  width: 80px;\n  height: 80px;\n}\n\n@media (max-width: 480px) {\n  .fullPageGifLoader img {\n    width: 45px;\n    height: 45px;\n  }\n}\n\n/* custom circle loader */\n\n.customCircleLoad {\n  border-radius: 50%;\n  border-style: solid;\n  animation:\n    customCircleOne 0.8s infinite linear alternate,\n    customCircleTwo 1.6s infinite linear;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n@keyframes customCircleOne {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)\n  }\n\n  12.5% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)\n  }\n\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)\n  }\n\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n  }\n\n  62.5% {\n    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n  }\n\n  75% {\n    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)\n  }\n\n  100% {\n    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)\n  }\n}\n\n@keyframes customCircleTwo {\n  0% {\n    transform: scaleY(1) rotate(0deg)\n  }\n\n  49.99% {\n    transform: scaleY(1) rotate(135deg)\n  }\n\n  50% {\n    transform: scaleY(-1) rotate(0deg)\n  }\n\n  100% {\n    transform: scaleY(-1) rotate(-135deg)\n  }\n}\n\n/* text loader */\n\n.loadingTextContainer p {\n  margin-bottom: 0;\n}\n\n.loadingTextWrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.loadingTextWrapper .loadingTextSpan {\n  animation-name: blink;\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: both;\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  background: var(--primary-foreground);\n  border-radius: 50%;\n}\n\n.loadingTextWrapper .loadingTextSpan:nth-child(2) {\n  animation-delay: .2s;\n}\n\n.loadingTextWrapper .loadingTextSpan:nth-child(3) {\n  animation-delay: .4s;\n}\n\n\n@keyframes blink {\n  0% {\n    opacity: .2;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: .2;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textCenter": `Loader-textCenter-_W1PN`,
	"fullPageGifLoader": `Loader-fullPageGifLoader-lyaQP`,
	"customCircleLoad": `Loader-customCircleLoad-V0rul`,
	"customCircleOne": `Loader-customCircleOne-Y5tJO`,
	"customCircleTwo": `Loader-customCircleTwo-ycPU8`,
	"loadingTextContainer": `Loader-loadingTextContainer-uqYo4`,
	"loadingTextWrapper": `Loader-loadingTextWrapper-smZ3y`,
	"loadingTextSpan": `Loader-loadingTextSpan-XOUfv`,
	"blink": `Loader-blink-ZVBPT`
};
module.exports = ___CSS_LOADER_EXPORT___;
